import loadable from '@loadable/component';

export const UpdateMobileAppLoadable = loadable(() => import('./UpdateMobileApp'), {
  fallback: undefined,
  ssr: false,
});
